export type AgentScope = 'Global' | 'Project'

export type AgentMemoryEntryType = 'Fact' | 'Feedback'

export type AgentMemoryEntrySource = 'RunOutput' | 'Feedback'

export interface Agent {
  id: string
  name: string
  displayName: string
  description: string | null
  scope: AgentScope
  projectId: string | null
  isGlobal: boolean
  isReadOnly: boolean
  latestVersion: string | null
  latestVersionId: string | null
  memoryEnabled: boolean
}

export interface AgentVersion {
  id: string
  agentId: string
  version: string
  yamlSnapshot: string
  contentHash: string
  createdAt: string
  createdByName: string | null
}

export interface AgentDetail {
  id: string
  name: string
  displayName: string
  description: string | null
  scope: AgentScope
  projectId: string | null
  isGlobal: boolean
  isReadOnly: boolean
  yamlContent: string
  latestVersion: AgentVersion | null
  memoryEnabled: boolean
}

export interface AgentMemoryEntry {
  id: string
  agentId: string
  projectId: string
  type: AgentMemoryEntryType
  content: string
  createdAt: string
  source: AgentMemoryEntrySource | null
  sourceRunId: string | null
}

export interface CreateAgentRequest {
  name: string
  displayName: string
  description?: string
  yaml: string
}

export interface UpdateAgentRequest {
  displayName: string
  description?: string
}


export interface CreateAgentVersionRequest {
  yaml: string
}

export interface CreateAgentResponse {
  agentId: string
  agentVersionId: string
  version: string
}

export interface CreateAgentVersionResponse {
  agentId: string
  agentVersionId: string
  version: string
}

export interface CreateAgentMemoryEntryRequest {
  type: AgentMemoryEntryType
  content: string
}

export interface UpdateAgentMemoryEntryRequest {
  content: string
}

export interface CreateAgentMemoryEntryResponse {
  entryId: string
  agentId: string
  type: AgentMemoryEntryType
}

export type AgentCategory = 'System' | 'Custom'

export const AGENT_CATEGORIES: AgentCategory[] = ['System', 'Custom']

export function agentCategory(agent: Pick<Agent, 'isGlobal'>): AgentCategory {
  return agent.isGlobal ? 'System' : 'Custom'
}
